<template>
  <Slidebar @closeMe="closeSlidebar" :large="large" :extraLarge="extraLarge">
    <h4 v-if="id">{{ item.heiti_astundun }}</h4>
    <h4 v-else>Stofna tegund ástundun eða hegðun</h4>
    <br />
    <b-form @submit.prevent="validateBeforeSubmit" novalidate>
      <table class="table less-padding">
        <tr>
          <td>Heiti*</td>
          <td>
            <b-form-group
              label-for="heiti"
              :state="submitted && errors.has('heiti') ? false : ''"
              :invalid-feedback="errors.first('heiti')"
            >
              <b-form-input
                id="heiti"
                name="heiti"
                type="text"
                v-model="form.heiti_astundun"
                :state="submitted && errors.has('heiti') ? false : ''"
                maxLength="100"
                v-validate="'required'"
                ref="focusInput"
                data-vv-as="heiti"
              ></b-form-input>
            </b-form-group>
          </td>
        </tr>
        <tr v-if="id">
          <td>Virk</td>
          <td>
            <b-form-group label-for="virk">
              <b-form-checkbox id="virk" name="virk" v-model="form.enabled"></b-form-checkbox>
            </b-form-group>
          </td>
        </tr>
        <tr v-if="!id">
          <td>Flokkur</td>
          <td>
            <b-form-group label-for="type">
              <v-select id="type" name="type" v-model="form.type" :options="typeList" :clearable="false" data-vv-as="tegund"> </v-select>
            </b-form-group>
          </td>
        </tr>
      </table>
      <b-btn variant="primary" class="mr-2" v-if="canEdit" @click="validateBeforeSubmit">
        <span v-if="id">Breyta</span>
        <span v-else>Stofna</span>
      </b-btn>
      <b-btn variant="dark" @click="closeSlidebar">Hætta við</b-btn>
      <b-btn variant="danger" class="float-right" v-if="canEdit && id" @click="deleteBehavior"> Eyða </b-btn>
    </b-form>
  </Slidebar>
</template>

<script>
import types from '@/api/types';
import { mapActions, mapGetters } from 'vuex';

import Slidebar from '@/components/common/Slidebar.vue';

export default {
  name: 'behavior-type-slidebar',
  props: ['item', 'large', 'extraLarge'],
  components: {
    Slidebar,
  },
  computed: {
    canEdit() {
      return this.loggedInUserHasWritePermission('skolahald_uppbygging');
    },
    ...mapGetters(['loggedInUserHasReadPermission', 'loggedInUserHasWritePermission']),
  },
  data() {
    return {
      loading: false,
      submitted: false,
      id: null,
      typeList: [
        { id: 1, label: 'Ástundun' },
        { id: 2, label: 'Hegðun' },
      ],
      form: {
        heiti_astundun: '',
        enabled: true,
        type: { id: 1, label: 'Ástundun' },
      },
    };
  },
  methods: {
    closeSlidebar() {
      this.$emit('closeSlidebar');
    },
    async loadBehaviorDetail() {
      try {
        this.loading = true;
        const response = await types.getBehaviorDetail(this.id);
        if (response.data.items && response.data.items.length > 0) {
          const item = response.data.items[0];
          this.form.heiti_astundun = item.heiti_astundun;
          this.form.enabled = item.enabled === 1;
          this.form.type = this.typeList.find(x => x.id === item.type);
        }
      } catch (e) {
        // Aðgerð mistókst.
        this.failed = true;
        this.$log.debug(e);
        this.displayError(`Óvænt villa (${e.response ? e.response.status : -1}) kom upp. Vinsamlegast reyndu aftur.`);
      } finally {
        this.loading = false;
      }
    },
    async validateBeforeSubmit() {
      try {
        this.submitted = true;
        this.errorList = [];
        await this.$validator.validateAll().then(response => {
          if (!response) throw 'FormValidationError'; // eslint-disable-line no-throw-literal
        });

        // Engar villur í formi.
        try {
          this.saving = true;
          const data = {
            heiti_astundun: this.form.heiti_astundun,
            type: this.form.type.id,
            enabled: this.form.enabled ? 1 : 0,
          };
          if (this.id) {
            await types.updateBehavior(this.id, data);
            this.displaySuccess(`${this.form.heiti_astundun} hefur verið breytt.`);
          } else {
            await types.createBehavior(data);
            this.displaySuccess(`${this.form.heiti_astundun} hefur verið stofnuð.`);
          }
          this.closeSlidebar();
        } catch (e) {
          // Aðgerð mistókst.
          this.failed = true;
          this.$log.debug(e);
          if (e.response && e.response.data && e.response.data.error) {
            this.displayError(e.response.data.error);
          } else {
            this.displayError(`Óvænt villa (${e.response ? e.response.status : -1}) kom upp. Vinsamlegast reyndu aftur.`);
          }
        }
      } catch (e) {
        // Villur í formi.
        this.$log.debug(e);
      } finally {
        this.saving = false;
      }
    },
    async deleteBehavior() {
      try {
        const conf = confirm(`Ert þú viss um að eyða ${this.item.heiti_astundun}?`); // eslint-disable-line
        if (conf) {
          await types.updateBehavior(this.id, { delete: 1 });
          this.displaySuccess(`${this.item.heiti_astundun} hefur verið eytt.`);
          this.closeSlidebar();
        }
      } catch (e) {
        // Aðgerð mistókst.
        this.$log.debug(e);
        if (e.response && e.response.data && e.response.data.error) {
          this.displayError(e.response.data.error);
        } else {
          this.displayError(`Óvænt villa (${e.response ? e.response.status : -1}) kom upp. Vinsamlegast reyndu aftur.`);
        }
      }
    },
    ...mapActions({
      displayError: 'displayError',
      displaySuccess: 'displaySuccess',
    }),
  },
  watch: {
    item() {
      this.form = {
        heiti_astundun: '',
        enabled: true,
        type: { id: 1, label: 'Ástundun' },
      };
      this.id = null;
      if (this.item && this.item.tegund_astundun_id) {
        this.id = this.item.tegund_astundun_id;
        this.loadBehaviorDetail();
      }
      this.$nextTick(() => {
        if (this.$refs.focusInput) {
          this.$refs.focusInput.focus();
        }
      });
    },
  },
  created() {
    this.form = {
      heiti_astundun: '',
      enabled: true,
      type: { id: 1, label: 'Ástundun' },
    };
    this.id = null;
    if (this.item && this.item.tegund_astundun_id) {
      this.id = this.item.tegund_astundun_id;
      this.loadBehaviorDetail();
    }
    this.$nextTick(() => {
      if (this.$refs.focusInput) {
        this.$refs.focusInput.focus();
      }
    });
  },
};
</script>

<style lang="scss"></style>
